import mitt, { Emitter } from 'mitt';
import { Events } from './events';

export default mitt<Events>() as Emitter<Events>;
